"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployerUserFactory = void 0;
const testing_1 = require("@engineering11/testing");
const user_shared_1 = require("@engineering11/user-shared");
class EmployerUserFactory extends testing_1.BaseMockFactory {
    defaultData() {
        const baseUser = new user_shared_1.UserMockFactory().mock();
        const employerUser = { ...baseUser, department: (0, testing_1.fakeDepartment)() };
        return employerUser;
    }
}
exports.EmployerUserFactory = EmployerUserFactory;
